export default {
  offers: {
    offersHeading: 'Offres standards',
    discountAmount: 'Montant de la remise',
    discountPercentage: 'Pourcentage de la remise',
    noOffers:
      'Aucune offre ajoutée. Cliquez sur "Ajouter une offre" pour en créer une.',
    saveSelectedOffers: 'Enregistrer les offres sélectionnées',
    loading: 'Chargement...',
    addNewOffer: 'Ajouter une offre',
    editOffer: "Modifier l'offre",
    edit: 'Modifier',
    remove: 'Supprimer',
    save: 'Enregistrer',
    saving: 'Enregistrement...',
    saveOffers: 'Payer',
    create: 'Créer',
    cancel: 'Annuler',
    description: 'Description',
    enterOfferName: "Saisir le nom de l'offre",
    enterDescription: "Décrire l'offre brièvement",
    inclusions: 'Inclusions (une par ligne)',
    inclusionsPlaceholder: 'Mobilier de stand\nWiFi\n2 badges\nÉlectricité',
    inclusionsHelper: 'Saisir chaque inclusion sur une nouvelle ligne',
    successCreate: 'Offre créée avec succès',
    successUpdate: 'Offre mise à jour avec succès',
    successDelete: 'Offre supprimée avec succès',
    errors: {
      save: 'Erreur lors de la sauvegarde des offres. Veuillez réessayer.',
      nameRequired: "Veuillez saisir le nom de l'offre",
      priceInvalid: 'Veuillez saisir un prix valide',
    },
  },
};
